import React from "react";

const TONES = {
  default: "bg-[var(--panel-2)] text-[var(--muted)] border border-[var(--line)]",
  log: "bg-[var(--accent-soft)] text-[var(--accent)] border-transparent",
  susp: "bg-[var(--amber-soft)] text-[var(--amber)] border-transparent",
};

const Tag = ({ tone = "default", children }) => (
  <span className={["text-[11px] font-semibold px-[9px] py-[3px] rounded-[6px]", TONES[tone]].join(" ")}>
    {children}
  </span>
);

export default Tag;
